// src/components/PatientToProviderMessagesPanel.jsx
import React, { useState } from "react";
import { sendMessage } from "../APIs/messageService";

export default function PatientToProviderMessagesPanel({
  patientId,
  providerId,
}) {
  const [composer, setComposer] = useState("");
  const [sending, setSending] = useState(false);
  const [err, setErr] = useState("");

  const onSend = async (e) => {
    e.preventDefault();
    if (!composer.trim() || !providerId) return;

    setSending(true);
    setErr("");
    try {
      await sendMessage({
        senderPatientId: patientId,
        recipientProviderId: providerId,
        content: composer.trim(),
      });
      setComposer("");
      alert("Message sent!");
    } catch (error) {
      console.error(error);
      setErr("Failed to send.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="p-4 border rounded-2xl bg-white shadow-sm">
      <h4 className="text-lg font-semibold mb-2">Send a Message</h4>
      <form onSubmit={onSend} className="space-y-2">
        <textarea
          className="w-full border rounded p-2 resize-none"
          rows={4}
          placeholder="Type your message..."
          value={composer}
          onChange={(e) => setComposer(e.target.value)}
          disabled={sending}
        />
        {err && <div className="text-red-600 text-sm">{err}</div>}
        <button
          type="submit"
          className="px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50"
          disabled={sending || !composer.trim()}
        >
          {sending ? "Sending…" : "Send"}
        </button>
      </form>
    </div>
  );
}
